import React, { useCallback, useState } from "react";
import Box from "@mui/material/Box";
import { getPreviewCameraId } from "../../lib/dashboardSession.ts";
import { DashboardCameraSection } from "../../components/place360/DashboardCameraSection.tsx";
import "../../styles/omniWatchPlace360.css";

export default function Wahankhede360Page() {
  const [previewCameraId, setPreviewCameraId] = useState<string | null>(() =>
    getPreviewCameraId(),
  );

  const handlePreviewCameraIdChange = useCallback((id: string | null) => {
    setPreviewCameraId(id);
  }, []);

  return (
    <Box
      className="ds-w360-page"
      sx={{
        bgcolor: "#f5f5f5",
        px: 0,
        py: 0.5,
        boxSizing: "border-box",
      }}
    >
      <Box
        className="ds-w360-shell"
        sx={{
          bgcolor: "#fff",
          borderRadius: "4px",
          border: "1px solid rgba(0, 0, 0, 0.06)",
          boxShadow: "none",
          overflow: "hidden",
        }}
      >
        <Box className="ds-body" sx={{ px: 2, pb: 1, pt: 1 }}>
          <DashboardCameraSection
            previewCameraId={previewCameraId}
            onPreviewCameraIdChange={handlePreviewCameraIdChange}
          />
        </Box>
      </Box>
    </Box>
  );
}
